// src/components/MeetingNavigationConfirmDialog.tsx
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const MeetingNavigationConfirmDialog: React.FC<Props> = ({ open, onConfirm, onCancel }) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle>Leave Session?</DialogTitle>
    <DialogContent>
      You have an ongoing session. Are you sure you want to leave? Unsaved progress may be lost.
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Stay</Button>
      <Button onClick={onConfirm} color="error" variant="contained">Leave</Button>
    </DialogActions>
  </Dialog>
);

export default MeetingNavigationConfirmDialog;